"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncHelper = exports.DateHelper = void 0;
class DateHelper {
    static addSeconds(secondsToAdd, date) {
        const result = new Date(date);
        result.setSeconds(result.getSeconds() + secondsToAdd);
        return result;
    }
}
exports.DateHelper = DateHelper;
class AsyncHelper {
    static async parallel(array, fn) {
        const promises = [];
        array.forEach((item) => promises.push(fn(item)));
        return await Promise.all(promises);
    }
    static async pause(milliseconds) {
        await new Promise((resolve) => {
            setTimeout(resolve, milliseconds);
        });
    }
    static async waitUntil(isReady, checkInterval = 50, timeout = 10000) {
        const start = Date.now();
        return new Promise((resolve, reject) => {
            const checkFn = () => {
                try {
                    if (isReady()) {
                        resolve();
                    }
                    else {
                        if (start + timeout < Date.now()) {
                            reject(new Error('timeout'));
                        }
                        else {
                            setTimeout(checkFn, checkInterval);
                        }
                    }
                }
                catch (e) {
                    reject(e);
                }
            };
            setTimeout(checkFn, checkInterval);
        });
    }
}
exports.AsyncHelper = AsyncHelper;
//# sourceMappingURL=helper.js.map